import React from "react";
import { Link } from "react-router-dom";
import {
  Mail,
  Phone,
  MapPin,
  Linkedin,
  Facebook,
  Twitter,
  Send,
  Target,
  Users,
} from "lucide-react";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#0f172a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-14">
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <div className="flex items-center gap-2 text-lg font-semibold">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 text-white">
                <Send className="w-5 h-5" />
              </span>
              <span>Plateforme LMS</span>
            </div>
            <p className="text-sm text-white/70 leading-relaxed">
              Accelerez votre prospection et pilotez vos objectifs de chiffre
              d'affaires avec une vue complète sur vos prospects, interactions
              et contrats signés.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white/70">
              Navigation
            </h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li>
                <Link
                  to="/dashboard"
                  className="hover:text-white transition-colors"
                >
                  Tableau de bord
                </Link>
              </li>
              <li>
                <Link
                  to="/leads"
                  className="hover:text-white transition-colors"
                >
                  Prospects
                </Link>
              </li>
              <li>
                <Link
                  to="/leads/add"
                  className="hover:text-white transition-colors"
                >
                  Nouveau prospect
                </Link>
              </li>
              <li>
                <Link
                  to="/admin"
                  className="hover:text-white transition-colors"
                >
                  Administration
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white/70">
              Ressources
            </h3>
            <ul className="space-y-2 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <Target className="w-4 h-4 text-blue-300" />
                <span>Objectifs & prévisions</span>
              </li>
              <li className="flex items-center gap-2">
                <Users className="w-4 h-4 text-blue-300" />
                <span>Suivi des commerciaux</span>
              </li>
              <li>
                <a
                  href="https://firebase.google.com"
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white transition-colors"
                >
                  Documentation Firebase
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@plateforme-lms.com?subject=Support"
                  className="hover:text-white transition-colors"
                >
                  Support & assistance
                </a>
              </li>
            </ul>
          </div>

          <div className="space-y-4">
            <h3 className="text-sm font-semibold uppercase tracking-wide text-white/70">
              Contact
            </h3>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-blue-300" />
                <a href="#" className="hover:text-white transition-colors">
                  -
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-blue-300" />
                <a href="#" className="hover:text-white transition-colors">
                  -
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-blue-300" />
                <span>-</span>
              </li>
            </ul>

            <div className="flex items-center gap-3 pt-2">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-4 h-4" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex flex-col gap-2 md:flex-row md:items-center md:justify-between text-xs text-white/60">
          <p>Copyright {year} Plateforme LMS. Tous droits réservés.</p>
          <div className="flex items-center gap-4">
            <Link
              to="/mentions-legales"
              className="hover:text-white transition-colors"
            >
              Mentions legales
            </Link>
            <Link
              to="/confidentialite"
              className="hover:text-white transition-colors"
            >
              Politique de confidentialité
            </Link>
            <Link
              to="/conditions"
              className="hover:text-white transition-colors"
            >
              Conditions d'utilisation.
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
